module.exports = __webpack_public_path__ + "static/media/video-translation.93824dc8.svg";